export type StoreCallback<T = unknown> = (value: T | undefined) => void;

export class AppStore {
  static readonly instance = new AppStore();

  private data = new Map<string, unknown>();
  private subscribers = new Map<string, Set<StoreCallback>>();

  private constructor() {}

  set<T>(key: string, value: T): void {
    this.data.set(key, value);
    this.notify(key, value);
  }

  get<T>(key: string): T | undefined {
    return this.data.get(key) as T | undefined;
  }

  has(key: string): boolean {
    return this.data.has(key);
  }

  delete(key: string): boolean {
    const deleted = this.data.delete(key);
    if (deleted) {
      this.notify(key, undefined);
    }
    return deleted;
  }

  on<T>(key: string, callback: StoreCallback<T>): () => void {
    let set = this.subscribers.get(key);
    if (!set) {
      set = new Set();
      this.subscribers.set(key, set);
    }
    const cb = callback as StoreCallback;
    set.add(cb);
    return () => {
      set!.delete(cb);
    };
  }

  clear(): void {
    for (const [key, set] of this.subscribers) {
      if (set.size > 0 && this.data.has(key)) {
        this.notify(key, undefined);
      }
    }
    this.data.clear();
    this.subscribers.clear();
  }

  private notify(key: string, value: unknown): void {
    const set = this.subscribers.get(key);
    if (!set) return;
    for (const cb of [...set]) {
      try {
        cb(value);
      } catch (err) {
        console.error(`[AppStore] Errore nel subscriber per "${key}":`, err);
      }
    }
  }
}

export const appStore = AppStore.instance;
